const STRINGS = {
  selectedText: ", selected"
};
export default STRINGS;